import React from 'react';
import { Trophy, Calendar, AlertCircle } from 'lucide-react';
import { registrationPricing, teamInfo } from '../../mock';

/**
 * Auto-generated registration flyer.
 *
 * Renders the 2026 season pricing entirely from `registrationPricing` in mock.js
 * so the flyer can never drift out of sync with the live pricing cards.
 *
 * Falls back automatically if a future custom flyer image is uploaded — pass
 * `flyerImage` and the image will render instead.
 */
const PricingFlyer = ({ flyerImage }) => {
  if (flyerImage) {
    return (
      <img
        src={flyerImage}
        alt="2026 Randallstown Panthers Registration Pricing"
        className="price-flyer-image"
        data-testid="pricing-flyer-image"
      />
    );
  }

  const programs = [
    { name: 'Tackle Football', tagline: 'Ages 7u – 13u', tiers: registrationPricing.tackle },
    { name: 'Cheerleading', tagline: 'Ages 5 – 14', tiers: registrationPricing.cheer },
    { name: 'Flag Football', tagline: 'Ages 5 – 6', tiers: registrationPricing.flag },
    { name: 'Girls Flag Football', tagline: 'Ages 12 – 14 · NEW', tiers: registrationPricing.girlsFlag },
    { name: 'Spring NFL FLAG', tagline: 'Ages 5 – 12', tiers: registrationPricing.springFlag },
  ];

  return (
    <div className="pricing-flyer" data-testid="pricing-flyer-generated">
      {/* Header */}
      <div className="pricing-flyer-header">
        <Trophy className="pricing-flyer-trophy" size={48} />
        <div>
          <p className="pricing-flyer-eyebrow">2026 SEASON</p>
          <h2 className="pricing-flyer-title">Randallstown Panthers</h2>
          <p className="pricing-flyer-subtitle">{teamInfo.tagline}</p>
        </div>
        <Trophy className="pricing-flyer-trophy" size={48} />
      </div>

      {/* Deadline pill */}
      <div className="pricing-flyer-deadline">
        <Calendar size={18} />
        <span>Registration closes <strong>August 15th, 2026</strong></span>
      </div>

      {/* Program tiles */}
      <div className="pricing-flyer-grid">
        {programs.map((program) => (
          <div key={program.name} className="pricing-flyer-card">
            <h3 className="pricing-flyer-card-title">{program.name}</h3>
            <p className="pricing-flyer-card-ages">{program.tagline}</p>
            <div className="pricing-flyer-tiers">
              {program.tiers.map((tier) => (
                <div key={`${program.name}-${tier.period}`} className="pricing-flyer-tier">
                  <span className="pricing-flyer-tier-period">{tier.period}</span>
                  <span className="pricing-flyer-tier-price">${tier.price}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Cancellation policy */}
      <div className="pricing-flyer-policy">
        <AlertCircle size={16} />
        <span>{registrationPricing.cancellationPolicy.replace(/\*+/g, '')}</span>
      </div>

      <p className="pricing-flyer-foot">
        All official registrations are completed on the My&nbsp;Rec portal. This page is for
        pricing reference and to express interest.
      </p>
    </div>
  );
};

export default PricingFlyer;
